import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TaxonomySettings } from '../settings/Taxonomy';
import { TopicCustomFieldsSettings } from '../settings/TopicCustomFields';
import { PublishingSettings } from '../settings/Publishing';
import { InkSection } from '../cms/shared';

/**
 * TinyCMS → Content settings. Taxonomy, custom fields, and publishing rules.
 * The left column owns each title. The editors render only their card.
 */
export function ContentSettings() {
  useEffect(() => {
    const id = window.location.hash.replace('#', '');
    if (!id) return;
    document.getElementById(id)?.scrollIntoView({ block: 'start' });
  }, []);

  return (
    <main className="ink-body">
      <Link to="/content" className="ink-muted" style={{ textDecoration: 'none' }}>
        ← Content
      </Link>
      <h1 className="ink-h1" style={{ marginTop: 10 }}>
        Content settings
      </h1>
      <p className="ink-lede" style={{ paddingBottom: 12 }}>
        How content is structured, and the checks it passes before it goes live. Agents read these
        too.
      </p>
      <InkSection
        id="taxonomy"
        title="Taxonomy"
        description="The allowed terms for classifying content. Atomize picks only from these."
      >
        <TaxonomySettings embedded />
      </InkSection>
      <InkSection
        id="fields"
        title="Custom fields"
        description="Extra structured data for each article. These are visible only to this account."
      >
        <TopicCustomFieldsSettings embedded />
      </InkSection>
      <InkSection
        id="publishing"
        title="Publishing rules"
        description="Checks every article passes before it goes live, and the house style the copy edit follows."
      >
        <PublishingSettings embedded />
      </InkSection>
    </main>
  );
}
